import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import RandomContent from '../Components/RandomContent';
import { base64ToAscii } from '../Conversion/Base64';

const Base64ToAscii = () => {
  const [inputData, setInputData] = useState('');
  const [outputData, setOutputData] = useState('');
  const [isError, setIsError] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
  const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });

  useEffect(() => {
    setInputData('');
    setOutputData('');
    setIsError(false);
  }, []);

  const handleConversion = () => {
    const { converted, isError } = base64ToAscii(inputData);
    setOutputData(converted);
    setIsError(isError);
  };

  return (
    <>
      <div>
        <Header />

        <RandomContent />

        {/* Intro Section */}
        <div className="blog-area pb-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="details">
                    <h4><a href="#">Base64 to ASCII Converter</a></h4>
                    <p>
                      Decode your Base64-encoded text effortlessly using Data Beautifier's Free Base64 to ASCII Converter Online Tool.
                      Our Best Base64 to ASCII Converter Online Tool converts Base64 data back into readable ASCII text, making it perfect
                      for developers, data analysts, and security professionals. Designed for simplicity, our Simple Base64 to ASCII
                      Converter Tool requires no technical expertise. With the Easy Base64 to ASCII Converter Tool, you can decode
                      Base64-encoded data in just a few clicks. Accessible anytime and completely free, Data Beautifier provides reliable
                      results for all your Base64 decoding needs. Try it today!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Input / Button / Output Section */}
        <div className="blog-area pb-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">

              {/* Input Box */}
              <div className="full-col col-lg-5 col-md-5">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="thumb">
                    <Inputs
                      value={inputData}
                      setValue={(val) => {
                        setInputData(val);
                        setIsError(false);
                      }}
                      fontSize={fontSize}
                      setFontSize={setFontSize}
                      isError={false}
                      lineCol={inputLnCol}
                      setLineCol={setInputLnCol}
                      readOnly={false}
                      idPrefix="input"
                      placeholder="Input Base64"
                    />
                  </div>
                </div>
              </div>

              {/* Convert Button */}
              <div
                className="w3-col m2"
                style={{
                  flex: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <button
                  className="default-btn icon four"
                  onClick={handleConversion}
                  disabled={!inputData.trim()}
                >
                  <i className="ri-exchange-line"></i>
                  Convert
                </button>
              </div>

              {/* Output Box */}
              <div className="full-col col-lg-5 col-md-5">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                  <div className="thumb">
                    <Output
                      value={outputData}
                      lineCol={outputLnCol}
                      setLineCol={setOutputLnCol}
                      fontSize={fontSize}
                      setFontSize={setFontSize}
                      isError={isError}
                      readOnly={true}
                      idPrefix="output"
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Base64ToAscii;
